import { useCallback, useState, useContext, useEffect, useMemo, Suspense } from "react";

import { TostMsg } from "../../../App";

import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import {
  addEmployeeExclusion,
  getExclusionEmployeeList,
  getInclusionEmployeeList,
  removeEmployeeExclusion,
  resetEmployees,
  saveDefaultReviewers,
  updateEmployeeReviewer,
  verifyIncludedEmployees,
} from "./PMSService";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";

/* ============================================================
   INTERNAL CSS
   (All classes are scoped under .og-card-assessment and use the
   "aae-" prefix so they don't clash with existing og-* classes)
============================================================ */



const AddnewEmployee = ({ cycleId, submitForm }) => {
  const userDetails = JSON.parse(localStorage.getItem("User") || "{}");

  const toster = useContext(TostMsg);

  // =========================================
  // STATE
  // =========================================

  const [inclusions, setInclusions] = useState([]);
  const [exclusions, setExclusions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [activeView, setActiveView] = useState("excluded");

  // Search for exclusion
  const [exclSearch, setExclSearch] = useState("");
  const [showExclDropdown, setShowExclDropdown] = useState(false);

  // Inclusion filters
  const [employeeSearch, setEmployeeSearch] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [designationFilter, setDesignationFilter] = useState("");
  const [reviewerFilter, setReviewerFilter] = useState("");

  // Pagination
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  // const [totalRecords, setTotalRecords] = useState(0);

  const [employees, setEmployee] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [isUpdatingReviewer, setIsUpdatingReviewer] = useState(false);
  const history = useHistory();
const [resetDefaultPopup, setResetDefaultPopup] = useState(false);
  // Default reviewer modal
  const [showDefaultReviewerModal, setShowDefaultReviewerModal] =
    useState(false);
  const [defaultReviewers, setDefaultReviewers] = useState({
    managerId: "",
    skipLevelId: "",
    normalizationActorId: "",
  });
  

  useEffect(() => {
    fetchEmployeeIdData();
    getDepartments();
  }, []);

  async function fetchEmployeeIdData() {
    setIsLoading(true);
    const params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
      ZoneId: 0,
      RegionId: 0,
      ProjectId: 0,
    };

    try {
      
      let employeesList = await getEmployeeList(params);
      setEmployee(employeesList.Data || []);
      setIsLoading(false);
    } catch (error) {
      toster.current.error(
        error.employeesList.Data?.Message || "somthing went wrong",
      );
    } finally {
      setIsLoading(false);
    }
  }

  const handleDefaultReviewerChange = (field, value) => {
    setDefaultReviewers((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFilterChange = (setter, value) => {
    setter(value);
    setPageNumber(1);
  };

  const applyDefaultReviewers = async () => {
    try {
      if (!cycleId) {
        toster.current.error("Cycle ID is required.");
        return;
      }
setIsLoading(true);
      const payload = {
        FirstReviewerId: Number(defaultReviewers.managerId) || 0,
        SecondReviewerId: Number(defaultReviewers.skipLevelId) || 0,
        NormalizationActorId:
          Number(defaultReviewers.normalizationActorId) || 0,
        ApplyToUnassignedOnly: true,
      };

      console.log("Default Reviewer Payload:", payload);

      const response = await saveDefaultReviewers(cycleId, payload);

      console.log("Default Reviewer API Response:", response);

      if(response?.StatusCode === 2000){
      toster.current.success(
        response?.message || "Default reviewers applied successfully.",
      );

      setShowDefaultReviewerModal(false);

      // Refresh employee list after applying defaults
      await getInclusionList();
    }
    setIsLoading(false);
    } catch (error) {
      console.error("Apply Default Reviewers Error:", error);

      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to apply default reviewers.";

      toster.current.error(message);
    } finally {
      setIsLoading(false);
    }
  };

  const resetDefaultEmployees = async () => {
    const params = {
      cycleId: cycleId,
    };

    try {

      setIsLoading(true);
      const response = await resetEmployees(params);

      await Promise.all([getInclusionList(), getExclusionList()]);

      if(response?.StatusCode === 2000){
        toster.current.success("Default list reseted successfully")
        setResetDefaultPopup(false);
      }
      else{
        toster.current.error(response?.Message);
      }
      setIsLoading(false);
    } catch (error) {
        setIsLoading(false);
    }
  };

  // =========================================
  // REVIEWER OPTIONS
  // =========================================

  const reviewerOptions = useMemo(() => {
    const reviewers = new Set();

    inclusions.forEach((employee) => {
      if (employee.manager) {
        reviewers.add(employee.manager);
      }

      if (employee.skipLevel) {
        reviewers.add(employee.skipLevel);
      }

      if (employee.normalizationActor) {
        reviewers.add(employee.normalizationActor);
      }
    });

    return Array.from(reviewers);
  }, [inclusions]);

  // =========================================
  // NORMALIZE EMPLOYEE DATA
  // =========================================

  const normalizeEmployee = useCallback((employee) => {
    return {
      ...employee,

      // IMPORTANT
      employeeId:
        employee?.Id ??
        employee?.EmpId ??
        employee?.EmployeeId ??
        employee?.employeeId ??
        employee?.id,

      name:
        employee?.FullName ?? employee?.EmployeeName ?? employee?.name ?? "",

      email: employee?.UserName ?? employee?.Email ?? employee?.email ?? "",

      department:
        employee?.CurrentDepartment ??
        employee?.Department ??
        employee?.department ??
        "",

      designation:
        employee?.CurrentDesignation ??
        employee?.Designation ??
        employee?.designation ??
        "",

      manager: employee?.ManagerId ?? employee?.managerId ?? "",

      skipLevel: employee?.SkipLevelId ?? employee?.skipLevelId ?? "",

      normalizationActor:
        employee?.NormalizationActorId ?? employee?.normalizationActorId ?? "",

      avatar: employee?.Initials ?? employee?.initials ?? "",

      avatarColor: employee?.AvatarColor ?? employee?.avatarColor ?? "#718096",
    };
  }, []);

  // =========================================
  // GET INCLUSION LIST
  // =========================================

  const getInclusionList = useCallback(async () => {
    setIsLoading(true);

    try {
      const response = await getInclusionEmployeeList({
        cycleId: cycleId,
        search: employeeSearch,
        department: departmentFilter,
        designation: designationFilter,
        reviewerStatus: reviewerFilter,
        pageNumber: pageNumber,
        pageSize: pageSize,
      });

      const data = response?.Data ?? [];

      const employeeData = Array.isArray(data)
        ? data.map(normalizeEmployee)
        : [];

      setInclusions(employeeData);

      const total = response?.Data[0]?.TotalCount ?? 0;

      setTotalRecords(Number(total));
    } catch (error) {
      console.error("Inclusion API error:", error);

      setInclusions([]);
      setTotalRecords(0);
    } finally {
      setIsLoading(false);
    }
  }, [
    cycleId,
    employeeSearch,
    departmentFilter,
    designationFilter,
    reviewerFilter,
    pageNumber,
    pageSize,
    normalizeEmployee,
  ]);
  // =========================================
  // GET EXCLUSION LIST
  // =========================================

  const getExclusionList = useCallback(async () => {
    // if (!cycleId) return;
  setIsLoading(true);
    try {
      const response = await getExclusionEmployeeList({
        cycleId: cycleId,
      });

      const data = response?.data ?? response?.Data ?? [];

      const employees = Array.isArray(data) ? data.map(normalizeEmployee) : [];

      setExclusions(employees);
        setIsLoading(false);
    } catch (error) {
      console.error("Exclusion API error:", error);

      setExclusions([]);
        setIsLoading(false);
    }
  }, [cycleId, normalizeEmployee]);

  // =========================================
  // INITIAL API CALLS
  // =========================================

  useEffect(() => {
    // if (!cycleId) return;

    getInclusionList();
    getExclusionList();
  }, [cycleId, getInclusionList, getExclusionList]);

  // =========================================
  // SEARCH EXCLUSION EMPLOYEES
  // =========================================

  const exclusionSearchResults = useMemo(() => {
    const search = exclSearch.trim().toLowerCase();

    if (!search) {
      return inclusions;
    }

    return inclusions.filter((employee) => {
      return (
        employee.name?.toLowerCase().includes(search) ||
        employee.email?.toLowerCase().includes(search)
      );
    });
  }, [inclusions, exclSearch]);

  const addExclusion = async (employees) => {
    // Normalize single employee -> array
    const employeeList = Array.isArray(employees) ? employees : [employees];

    // Remove invalid employees
    const validEmployees = employeeList.filter((employee) => employee?.EmpId);

    if (validEmployees.length === 0) {
      return;
    }

    // Get already excluded employee IDs
    const alreadyExcludedIds = exclusions.map((item) => item.EmpId);

    // Remove employees that are already excluded
    const newEmployees = validEmployees.filter(
      (employee) => !alreadyExcludedIds.includes(employee.EmpId),
    );

    if (newEmployees.length === 0) {
      return;
    }

    // Create comma-separated employee IDs
    const excludedEmployeeIds = newEmployees
      .map((employee) => employee.EmpId)
      .join(",");

    const params = {
      EmpId: excludedEmployeeIds,
      ExclusionReason: "",
    };

    try {

      setIsLoading(true);

   const response = await addEmployeeExclusion(cycleId, params);


      if(response.StatusCode === 2000){

        toster.current.success('Employee excluded successfully');
      // Refresh both lists
      await Promise.all([getInclusionList(), getExclusionList()]);

      }

      setExclSearch("");
      setShowExclDropdown(false);

      return newEmployees.length;
    } catch (error) {
      console.error("Add exclusion error:", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const handleAllExclude = async () => {
    if (selectedEmployees.length === 0) {
      if (toster?.current?.error) {
        toster.current.error("Please select at least one employee");
      }
      return;
    }

    const selected = inclusions.filter((employee) =>
      selectedEmployees.includes(getEmployeeId(employee)),
    );

    if (selected.length === 0) {
      return;
    }

    try {
      setIsLoading(true);

      // Works for multiple employees
      await addExclusion(selected);

      setSelectedEmployees([]);

      if (toster?.current?.success) {
        toster.current.success(
          `${selected.length} employee(s) excluded successfully`,
        );
      }
    } catch (error) {
      console.error("Bulk exclude error:", error);

      if (toster?.current?.error) {
        toster.current.error("Failed to exclude selected employees");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // =========================================
  // REMOVE EXCLUSION
  // =========================================

  const removeExclusion = async (employees) => {
    // Normalize single employee / ID into an array
    const employeeList = Array.isArray(employees) ? employees : [employees];

    // Get employee IDs
    const employeeIds = employeeList
      .map((employee) =>
        typeof employee === "object" ? getEmployeeId(employee) : employee,
      )
      .filter(Boolean);

    if (employeeIds.length === 0) {
      return 0;
    }

    const params = {
      CycleId: cycleId,
      EmpId: employeeIds.join(","),
      OrgId: userDetails?.OrgId,
      UserId: userDetails?.EmpId,
    };

    try {
      setIsLoading(true);

    const response =   await removeEmployeeExclusion(params);

    if(response?.StatusCode === 2000){
toster.current.success('Employee included successfully');
      // Refresh lists only once
      await Promise.all([getInclusionList(), getExclusionList()]);
      
    }

      return employeeIds.length;
    } catch (error) {
      console.error("Remove exclusion error:", error);
      toster.current.error('Failed to include the employee.Please try again')
      
    } finally {
      setIsLoading(false);
    }
  };

  const handleAllInclude = async () => {
    if (selectedEmployees.length === 0) {
      toster?.current?.error?.("Please select at least one employee");
      return;
    }

    const selected = exclusions.filter((employee) =>
      selectedEmployees.includes(getEmployeeId(employee)),
    );

    if (selected.length === 0) {
      return;
    }

    try {
        setIsLoading(true);
      // Pass complete array instead of calling API separately
      const count = await removeExclusion(selected);

      setSelectedEmployees([]);

      if (count > 0) {
        toster?.current?.success?.(
          `${count} employee(s) included successfully`,
        );
      }
    } catch (error) {
      console.error("Bulk include error:", error);

      toster?.current?.error?.("Failed to include selected employees");
    }
    finally {
        setIsLoading(false);
    }
  };

  // =========================================
  // FILTER CHANGE
  // =========================================

  // const handleFilterChange = (setter, value) => {
  //   setter(value);
  //   setPageNumber(1);
  // };

  // =========================================
  // COUNTS
  // =========================================

  const includedCount = totalRecords;

  const excludedCount = exclusions.length;
  const updateReviewer = async (employeeId, field, value) => {
    const employee = inclusions.find(
      (item) => Number(getEmployeeId(item)) === Number(employeeId),
    );

    if (!employee) {
      console.error("Employee not found:", employeeId);
      return;
    }

    /*
     * Get current reviewer values.
     */
    let firstReviewerId = employee?.FirstReviewerId ?? employee?.manager ?? "";

    let secondReviewerId =
      employee?.SecondReviewerId ?? employee?.skipLevel ?? "";

    let normalizationActorId =
      employee?.NormalizationActorId ?? employee?.normalizationActor ?? "";

    /*
     * Replace only the field which was changed.
     */
    if (field === "manager") {
      firstReviewerId = value;
    }

    if (field === "skipLevel") {
      secondReviewerId = value;
    }

    if (field === "normalizationActor") {
      normalizationActorId = value;
    }

    /*
     * Update UI immediately.
     */
    const updatedEmployee = {
      ...employee,

      FirstReviewerId: firstReviewerId,
      SecondReviewerId: secondReviewerId,
      NormalizationActorId: normalizationActorId,

      manager: firstReviewerId,
      skipLevel: secondReviewerId,
      normalizationActor: normalizationActorId,
    };

    setInclusions((prev) =>
      prev.map((item) =>
        Number(getEmployeeId(item)) === Number(employeeId)
          ? updatedEmployee
          : item,
      ),
    );

    console.log("Updating reviewer:", {
      employeeId,
      field,
      value,
      FirstReviewerId: firstReviewerId,
      SecondReviewerId: secondReviewerId,
      NormalizationActorId: normalizationActorId,
    });

    await updateReviewerApi(
      employeeId,
      firstReviewerId,
      secondReviewerId,
      normalizationActorId,
    );
  };

  const updateReviewerApi = async (
    employeeId,
    firstReviewerId,
    secondReviewerId,
    normalizationActorId,
  ) => {
    try {
      setIsUpdatingReviewer(true);

      const payload = {
        FirstReviewerId:
          firstReviewerId !== "" &&
          firstReviewerId !== null &&
          firstReviewerId !== undefined
            ? Number(firstReviewerId)
            : 0,

        SecondReviewerId:
          secondReviewerId !== "" &&
          secondReviewerId !== null &&
          secondReviewerId !== undefined
            ? Number(secondReviewerId)
            : 0,

        NormalizationActorId:
          normalizationActorId !== "" &&
          normalizationActorId !== null &&
          normalizationActorId !== undefined
            ? Number(normalizationActorId)
            : 0,
      };

      console.log("UPDATE REVIEWER PAYLOAD:", {
        cycleId,
        employeeId,
        payload,
      });

      const response = await updateEmployeeReviewer(
        cycleId,
        employeeId,
        payload,
      );

      /*
       * Refresh after successful update.
       */
      await getInclusionList();

      return true;
    } catch (error) {
      
      toster?.current?.error?.(
        error?.response?.data?.Message ||
          error?.response?.data?.message ||
          "Failed to update reviewer",
      );

      return false;
    } finally {
      setIsUpdatingReviewer(false);
    }
  };

  const getDepartments = async () => {
    let params = {
      masterType: "Department",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };
    try {
      let response = await GetMasterTypeData(params);
      setDepartments(response?.Data || []);
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  };

  const getEmployeeId = (employee) =>
    employee?.employeeId ??
    employee?.EmpId ??
    employee?.Id ??
    employee?.EmployeeId ??
    employee?.id;

  const isAllSelected =
    inclusions.length > 0 &&
    inclusions.every((employee) =>
      selectedEmployees.includes(getEmployeeId(employee)),
    );

  const handleEmployeeSelect = (employeeId) => {
    setSelectedEmployees((prev) => {
      if (prev.includes(employeeId)) {
        return prev.filter((id) => id !== employeeId);
      }

      return [...prev, employeeId];
    });
  };

  const handleSelectAll = (checked, type) => {
    const list = type === "inclusion" ? inclusions : exclusions;

    if (checked) {
      const ids = list
        .map((employee) => getEmployeeId(employee))
        .filter(Boolean);

      setSelectedEmployees(ids);
    } else {
      setSelectedEmployees([]);
    }
  };

  const totalPages = Math.ceil(totalRecords / pageSize);

  const handlePreviousPage = () => {
    if (pageNumber > 1) {
      setPageNumber((prev) => prev - 1);
      setSelectedEmployees([]);
    }
  };

  const handleNextPage = () => {
    if (pageNumber < totalPages) {
      setPageNumber((prev) => prev + 1);
      setSelectedEmployees([]);
    }
  };

  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setPageNumber(1);
    setSelectedEmployees([]);
  };

  const verifyEmployeesData = async () => {
    try {
        setIsLoading(true);
      const response = await verifyIncludedEmployees(cycleId);

      if (response?.Data?.Summary?.TotalWithIssues > 0) {
        toster.current.error(
          `${response?.Data?.Summary?.TotalWithIssues} employees have missing data. Required fields missing: First Reviewer, Second Reviewer, and Normalization By`,
        );
      } else {
        toster.current.success("Employee reviewers saved successfully");
        history.push("/Assessment/Cycles");
      }
        setIsLoading(false);
    } catch (error) {
        setIsLoading(false);
    }
  };

  // =========================================
  // RENDER
  // =========================================

  return (
    <div className="og-card-assessment">
      {/* Internal CSS */}
     

      {/* =====================================
          TOP TABS
      ====================================== */}

      <div className="aae-tabs-row">
        {/* Included */}

        <button
          type="button"
          onClick={() => setActiveView("included")}
          className={`aae-tab-btn aae-tab-included ${
            activeView === "included" ? "aae-active" : ""
          }`}
        >
          <i className="fa fa-check-circle" />

          <span>{includedCount} Included</span>

          <i className="fa fa-arrow-right aae-arrow-icon" />
        </button>

        {/* Excluded */}

        <button
          type="button"
          onClick={() => setActiveView("excluded")}
          className={`aae-tab-btn aae-tab-excluded ${
            activeView === "excluded" ? "aae-active" : ""
          }`}
        >
          <i className="fa fa-ban" />

          <span>{excludedCount} Excluded</span>
        </button>

        {/* Right buttons */}

        <div className="aae-actions">
          {activeView === "excluded" && (
            <>
              {/* ALL INCLUDE */}
              <button
                type="button"
                className="btn-og btn-og-secondary btn-og-sm"
                onClick={handleAllInclude}
                disabled={
                  activeView !== "excluded" ||
                  selectedEmployees.length === 0 ||
                  isLoading
                }
              >
                <i className="fa fa-check-circle" /> Bulk Include
              </button>
            </>
          )}

          {activeView === "included" && (
            <>
              {/* ALL EXCLUDE */}
              <button
                type="button"
                className="btn-og btn-og-secondary btn-og-sm aae-danger-btn"
                onClick={handleAllExclude}
                disabled={
                  activeView !== "included" ||
                  selectedEmployees.length === 0 ||
                  isLoading
                }
              >
                <i className="fa fa-ban" /> Bulk Exclude
              </button>
            </>
          )}

          {/* Selected count */}
          {selectedEmployees.length > 0 && (
            <span className="aae-selected-count">
              {selectedEmployees.length} selected
            </span>
          )}
        </div>

        <div className="aae-right-actions">
          <button
            type="button"
            className="btn btn-primary btn-og-sm"
            onClick={()=> setResetDefaultPopup(true)}
            
          >
            Reset to default list
          </button>
          {/* <button
            type="button"
            className="btn-og btn-og-secondary btn-og-sm"
            onClick={() => {
              console.log("Auto-assign reviewers");
            }}
          >
            <i className="fa fa-sitemap" /> Auto-assign Reviewers
          </button> */}

          <button
            type="button"
            className="btn-og btn-og-outline btn-og-sm"
            onClick={() => setShowDefaultReviewerModal(true)}
          >
            <i className="fa fa-users-gear" /> Set Default Reviewers
          </button>

          <button
            type="button"
            className="btn btn-outline btn-og-sm"
            onClick={() => verifyEmployeesData()}
          >
            <i className="fa fa-circle-arrow-left" /> Continue
          </button>
        </div>
      </div>

      {/* =====================================
          EXCLUDED VIEW
      ====================================== */}

      {activeView === "excluded" && (
        <div>
          {/* Search */}

          <div className="aae-search-wrap">
            <i className="fa fa-search aae-search-icon" />

            <input
              className="og-input aae-search-input"
              type="text"
              value={exclSearch}
              placeholder="Search employee name or email to exclude..."
              onChange={(e) => {
                setExclSearch(e.target.value);
                setShowExclDropdown(true);
              }}
              onFocus={() => setShowExclDropdown(true)}
            />

            {/* Dropdown */}

            {showExclDropdown && (
              <div className="aae-dropdown">
                {employees.length > 0 ? (
                  employees.map((employee) => (
                    <div
                      key={employee.Id}
                      className="excl-suggestion aae-suggestion"
                      onClick={() => addExclusion(employee)}
                    >
                      {/* <div
                        className="aae-sugg-av"
                        style={{
                          background: employee.avatarColor,
                        }}
                      >
                        {employee.avatar}
                      </div> */}

                      <div>
                        <div className="aae-sugg-name">{employee.FullName}</div>

                        <div className="aae-sub">
                          {employee.CurrentDesignation} · {employee.CurrentDepartment}
                        </div>
                      </div>

                      <button
                        type="button"
                        className="aae-sugg-btn"
                        onClick={(e) => {
                          e.stopPropagation();

                          addExclusion(employee);
                        }}
                      >
                        + Exclude
                      </button>
                    </div>
                  ))
                ) : (
                  <div className="aae-no-results">No employees found</div>
                )}
              </div>
            )}
          </div>

          {/* Exclusion Table */}

          <div className="og-table-wrap aae-scroll-x">
            <table className="og-table aae-table-min">
              <thead>
                <tr>
                  <th className="aae-th-check">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={(e) =>
                        handleSelectAll(e.target.checked, "exclusion")
                      }
                      title="Select all employees"
                    />
                  </th>
                  <th>Employee</th>
                  <th>Department</th>
                  <th>Designation</th>
                  <th>Excluded By</th>
                  {/* <th>Reason (optional)</th> */}
                  <th className="aae-th-action">Action</th>
                </tr>
              </thead>

              <tbody>
                {exclusions?.length > 0 ? (
                  exclusions?.map((employee) => (
                    <tr key={employee.EmpId}>
                      <td className="aae-td-center">
                        <input
                          type="checkbox"
                          checked={selectedEmployees.includes(employee.EmpId)}
                          onChange={() => handleEmployeeSelect(employee.EmpId)}
                        />
                      </td>

                      <td>
                        <div className="og-emp-cell">
                          {/* <div
                            className="og-emp-av aae-emp-av"
                            style={{
                              background: employee.avatarColor,
                            }}
                          >
                            {employee.avatar}
                          </div> */}

                          <div>
                            <div className="aae-emp-name">
                              {employee.name}
                            </div>

                            <div className="aae-sub">{employee.email}</div>
                          </div>
                        </div>
                      </td>

                      <td>{employee.Department}</td>

                      <td>{employee.Designation}</td>

                      <td>{employee.ExcludedByName ?? "-"}</td>

                      {/* <td>
                        <input
  className="og-input"
  type="text"
  value={employee.Reason || ""}
  placeholder="Add reason..."F
  style={{
    fontSize: "12px",
  }}
  onChange={(e) =>
    handleReasonChange(employee.EmpId, e.target.value)
  }
/>
                      </td> */}

                      <td>
                        <button
                          type="button"
                          className="btn-og btn-og-secondary btn-og-sm aae-include-btn"
                          onClick={() => removeExclusion(employee.EmpId)}
                        >
                          <i className="fa fa-rotate-left" /> Include
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="aae-empty">
                      No exclusion employees found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* =====================================
          INCLUDED VIEW
      ====================================== */}

      {activeView === "included" && (
        <div>
          {/* Filters */}

          <div className="aae-filters">
            <input
              className="og-input aae-flex1"
              type="text"
              placeholder="Search employee, department, designation..."
              value={employeeSearch}
              onChange={(e) =>
                handleFilterChange(setEmployeeSearch, e.target.value)
              }
            />

           
          </div>

          {/* Included Table */}

          <div className="og-table-wrap aae-scroll-both">
            <table className="og-table aae-table-min">
              <thead>
                <tr>
                  <th className="aae-th-check">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={(e) =>
                        handleSelectAll(e.target.checked, "inclusion")
                      }
                      title="Select all employees"
                    />
                  </th>
                  <th>Employee</th>
                  <th>Department /<br/> Designation</th>
                  {/* <th>Designation</th> */}
                  <th>Manager (1<sup>st</sup> Reviewer)</th>
<th>Skip-Level (2<sup>nd</sup> Reviewer)</th>
                  <th>Normalization By</th>
                  <th className="aae-th-action">Action</th>
                </tr>
              </thead>

              <tbody>
                {inclusions.length > 0 ? (
                  inclusions.map((employee) => (
                    <tr key={employee.EmpId}>
                      <td className="aae-td-center">
                        <input
                          type="checkbox"
                          checked={selectedEmployees.includes(employee.EmpId)}
                          onChange={() => handleEmployeeSelect(employee.EmpId)}
                        />
                      </td>

                      <td>
                        <div className="og-emp-cell">
                          {/* <div
                            className="og-emp-av aae-emp-av"
                            style={{
                              background: employee.avatarColor,
                            }}
                          >
                            {employee.avatar}
                          </div> */}

                          <div>
                            <div className="aae-emp-name">
                              {employee.name}
                            </div>

                            <div className="aae-sub">{employee.email}</div>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div>
                            <div className="aae-emp-name">
                              {employee.department}
                            </div>

                            <div className="aae-sub">{employee.designation}</div>
                          </div>
                        
                        </td>

                      {/* <td>{employee.designation}</td> */}

                      {/* Manager */}

                      <td>
                        <select
                          className="og-select aae-reviewer-select"
                          value={employee?.FirstReviewerId || ""}
                          onChange={(e) =>
                            updateReviewer(
                              employee?.EmpId,
                              "manager",
                              e.target.value,
                            )
                          }
                        >
                          <option value="">— Assign —</option>

                          {employees?.map((reviewer) => (
                            <option
                              key={reviewer?.EmpId}
                              value={reviewer?.EmpId}
                            >
                              {reviewer?.FullName}
                            </option>
                          ))}
                        </select>
                      </td>

                      {/* Skip Level */}

                      <td>
                        <select
                          className="og-select"
                          value={employee?.SecondReviewerId ?? ""}
                          onChange={(e) =>
                            updateReviewer(
                              employee?.EmpId,
                              "skipLevel",
                              e.target.value,
                            )
                          }
                        >
                          <option value="">— Assign —</option>

                          {employees?.map((reviewer) => (
                            <option
                              key={reviewer?.EmpId}
                              value={reviewer?.EmpId}
                            >
                              {reviewer?.FullName}
                            </option>
                          ))}
                        </select>
                      </td>

                      {/* Normalization */}

                      <td>
                        <select
                          className="og-select"
                          value={employee?.NormalizationActorId ?? ""}
                          onChange={(e) =>
                            updateReviewer(
                              employee?.EmpId,
                              "normalizationActor",
                              e.target.value,
                            )
                          }
                        >
                          <option value="">— Assign —</option>

                          {employees?.map((reviewer) => (
                            <option
                              key={reviewer?.EmpId}
                              value={reviewer?.EmpId}
                            >
                              {reviewer?.FullName}
                            </option>
                          ))}
                        </select>
                      </td>

                      {/* Exclude */}

                      <td>
                        {/* <button
                          type="button"
                          className="btn-og btn-og-secondary btn-og-sm"
                          style={{
                            color: " #3db51b",
                            borderColor: "#5f8064",
                            fontSize: "11px",
                          }}
                          onClick={() =>
                            updateReviewer(employee?.employeeId, "manager", "")
                          }
                        >
                          <i className="fa fa-check" />
                        </button> */}

                        <button
                          type="button"
                          className="btn-og btn-og-secondary btn-og-sm aae-exclude-btn"
                          onClick={() => addExclusion(employee)}
                        >
                          <i className="fa fa-ban" /> Exclude
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="aae-empty">
                      No inclusion employees found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {inclusions?.length > 0 && (
            <div className="aae-pager">
              {/* Showing information */}

              <span className="aae-pager-info">
                {totalRecords > 0 ? (
                  <>
                    Showing <strong>{(pageNumber - 1) * pageSize + 1}</strong>{" "}
                    to{" "}
                    <strong>
                      {Math.min(pageNumber * pageSize, totalRecords)}
                    </strong>{" "}
                    of <strong>{totalRecords}</strong> employees
                  </>
                ) : (
                  "Showing 0 of 0 employees"
                )}
              </span>

              {/* Pagination controls */}

              <div className="aae-pager-controls">
                {/* Page size */}

                <select
                  className="og-select aae-pagesize"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>

                {/* Previous */}

                <button
                  type="button"
                  className="btn-og btn-og-secondary btn-og-sm"
                  disabled={pageNumber === 1 || isLoading}
                  onClick={handlePreviousPage}
                >
                  <i className="fa fa-chevron-left" />
                  
                </button>

                {/* Page number */}

                <span className="aae-page-label">
                  Page {pageNumber} of {totalPages || 1}
                </span>

                {/* Next */}

                <button
                  type="button"
                  className="btn-og btn-og-secondary btn-og-sm"
                  disabled={
                    pageNumber >= totalPages || totalRecords === 0 || isLoading
                  }
                  onClick={handleNextPage}
                >
                  
                  <i className="fa fa-chevron-right" />
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Loader */}

      <div
        id="defRevModal"
        className={`og-modal-overlay ${showDefaultReviewerModal ? "open" : ""}`}
      >
        <div className="og-modal">
          <div className="og-modal-header">
            <div className="og-modal-title">Set Default Reviewers</div>

            <button
              className="og-modal-close"
              onClick={() => setShowDefaultReviewerModal(false)}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>

          <div className="modal-body">
            <div className="aae-info-banner">
              <i className="fa fa-circle-info aae-info-icon"></i>{" "}
              Applies to employees without individual assignments. Individual
              ones take priority.
            </div>

            {/* Manager */}
            <div className="og-form-group">
              <label className="og-label">Manager (First Reviewer)</label>

              <select
                className="og-select aae-reviewer-select"
                value={defaultReviewers.managerId}
                onChange={(e) =>
                  handleDefaultReviewerChange("managerId", e.target.value)
                }
              >
                <option value="">— Select Manager —</option>

                {employees?.map((reviewer) => (
                  <option key={reviewer?.EmpId} value={reviewer?.EmpId}>
                    {reviewer?.FullName}
                  </option>
                ))}
              </select>
            </div>

            {/* Skip Level */}
            <div className="og-form-group">
              <label className="og-label">Skip-Level (Second Reviewer)</label>

              <select
                className="og-select"
                value={defaultReviewers.skipLevelId}
                onChange={(e) =>
                  handleDefaultReviewerChange("skipLevelId", e.target.value)
                }
              >
                <option value="">— Select skip-level —</option>

                {employees?.map((reviewer) => (
                  <option key={reviewer?.EmpId} value={reviewer?.EmpId}>
                    {reviewer?.FullName}
                  </option>
                ))}
              </select>
            </div>

            {/* Normalization Actor */}
            <div className="og-form-group aae-mb0">
              <label className="og-label">Normalization By</label>

              <select
                className="og-select"
                value={defaultReviewers.normalizationActorId}
                onChange={(e) =>
                  handleDefaultReviewerChange(
                    "normalizationActorId",
                    e.target.value,
                  )
                }
              >
                <option value="">— Select Normalization By —</option>

                {employees?.map((reviewer) => (
                  <option key={reviewer?.EmpId} value={reviewer?.EmpId}>
                    {reviewer?.FullName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="modal-footer">
            <button
              className="btn-og btn-og-secondary"
              onClick={() => setShowDefaultReviewerModal(false)}
            >
              Cancel
            </button>

            <button
              className="btn-og btn-og-primary"
              type="button"
              onClick={applyDefaultReviewers}
            >
              Apply to Unassigned
            </button>
          </div>
        </div>
      </div>


      <div
        id="resetModal"
        className={`og-modal-overlay ${resetDefaultPopup ? "open" : ""}`}
      >
        <div className="og-modal modal-sm reset-modal">
          <div className="og-modal-header">
            <div className="og-modal-title">Reset to Default List</div>

            <button
              className="og-modal-close"
              onClick={() => setResetDefaultPopup(false)}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>

          <div className="modal-body">
            <div className="aae-info-banner">
              <i className="fa fa-circle-info aae-info-icon"></i>{" "}
             Are you sure you want to reset the default list?
            </div>

           

           

           
          </div>

          <div className="modal-footer">
            <button
              className="btn-og btn-og-secondary"
              onClick={() => setResetDefaultPopup(false)}
            >
              Cancel
            </button>

            <button
              className="btn-og btn-og-primary"
              type="button"
             onClick={resetDefaultEmployees}
            >
             Reset
            </button>
          </div>
        </div>
      </div>

      {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default AddnewEmployee;